import { uniqBy } from 'lodash';
import platformFacade from './PlatformFacade';
import { get } from '@/Libs/Request/index';
import uuid from 'uuid/v4';
import { OrderInfoRecord, OrdersRecord, TravellerRecord } from '@/Record/Orders';
import { gProcCalculateProfitMargin, tbExtractMessage } from '@/Libs/Orders';
import { truncate, calculate as calc, bNumber, add, sub } from '@/Libs/Decimal';

class AbstractClass {
  constructor() {
    this._data = [];
    this._exists = [];
  }

  get data() {
    return this._data;
  }
  set data(value) {
    this._data = value;
  }

  get exists() {
    return this._exists;
  }
  set exists(value) {
    this._exists = value;
  }

  async TemplateMethod() {
    await this.baseOperation1();
    await this.baseOperation2();
    await this.baseOperation3();
    await this.detectExists();
    return { origin: this.data, exists: this.exists };
  }

  async baseOperation1() {}

  async baseOperation2() {}

  async baseOperation3() {}

  async detectExists() {}
}

class Concrete extends AbstractClass {
  constructor(platformImportArg) {
    super();
    this.platformImportArg = platformImportArg;
  }

  // 获取基础数据
  async baseOperation1() {
    super.data = platformFacade(this.platformImportArg);
  }

  // 数据初始化
  async baseOperation2() {
    let data = [].concat(super.data);
    data = data.map((row) => {
      let amount = 0;
      let refund_fee = 0;
      row.traveller =
        row?.traveller?.filter((s) => s)?.map((item) => ({ ...new TravellerRecord().toJS(), ...item })) || [];
      row.orders_info = row.orders_info
        .map((item) => ({ ...new OrderInfoRecord().toJS(), ...item, sub_o_id: uuid() }))
        .map((oi) => {
          amount = add(amount, oi.transaction_amount);
          refund_fee = add(refund_fee, oi.refund_fee);
          let calcObj = {};
          gProcCalculateProfitMargin(
            oi,
            (err, price, supplier_offer, settlement_price, total_insurance, supplier_tax) => {
              calcObj = {
                profit: truncate(price, 8),
                profit_margin: Number(supplier_offer) === 0 ? null : calc(`${price} / ${supplier_offer}`),
                commission: truncate(calc(`${bNumber(oi.transaction_amount)}*${bNumber(oi.commission_rate)}`), 8),
                web_settlement: truncate(
                  calc(
                    `(${bNumber(oi.transaction_amount)} - (${bNumber(oi.transaction_amount)} * ${bNumber(
                      oi.commission_rate
                    )}))`
                  ),
                  8
                ),
                supplier_offer,
                settlement_price,
                supplier_tax,
              };
              // console.log(calcObj);
            }
          );
          return { ...oi, ...calcObj };
        });
      row.refund_fee = refund_fee;
      row.transaction_amount = amount;

      const extMessage = tbExtractMessage(row.web_remark);
      row.name = row.name || extMessage.name || '';
      row.email = row.email || extMessage.email || '';
      row.phone = row.phone || extMessage.phone || '';
      row.saler = row.saler || extMessage.saler || '';

      row.dividers_id = '1,2';
      row.created_by_id = localStorage.getItem('userId');

      return { ...new OrdersRecord().toJS(), ...row };
    });
    super.data = [].concat(data);
  }

  // 填充销售ID
  async baseOperation3() {
    let data = [].concat(this.data);
    let salerArr = uniqBy([].concat(this.data), 'saler')
      .filter((item) => item.saler != '')
      .map((item) => item.saler);
    salerArr = [].concat(salerArr);
    if (salerArr.length === 0) {
      return false;
    }
    const r = await (await get(`/api/users`, { q: salerArr.join(','), mult: 1 })).json();
    r.data.data.forEach((element) => {
      data.filter((item) => item.saler === element.real_name).forEach((item) => (item.saler_id = element.u_id));
    });
    super.data = [].concat(data);
  }

  // 检测存在
  async detectExists() {
    let ordersnArr = [].concat(this.data).map((row) => row.ordersn);
    if (ordersnArr.length === 0) return false;
    const res = await (
      await get(
        `/api/orders`,
        { type: 'search', ordersn: ordersnArr.join(',') },
        { headers: { page_size: ordersnArr.length } }
      )
    ).json();
    super.exists = [].concat(res.data.data?.map(r => r.ordersn));
  }
}

export default Concrete;
